export const flowsterPrivacy = {
  effectiveDate: 'July 1, 2024',
  contents: [
    {
      header: '1. Introduction',
      body: [
        'Welcome to Flowster! ATCREATE Inc. ("we," "our," "us") operates the Flowster mobile application (the “App”). This Privacy Policy explains how we collect, use, share, and safeguard your information when you use our App. Please read this privacy policy carefully. By using the App, you agree to the collection and use of information in accordance with this policy.  If you do not agree with the terms of this privacy policy, please do not access the App.',
      ],
    },
    {
      header: '2. Information We Collect',
      body: [
        'We may collect information about you in a variety of ways. The information we may collect via the App includes:',
      ],
    },
    {
      header: 'a. Personal Information',
      body: [
        'Personally identifiable information, such as your name, shipping address, email address, and telephone number, password and demographic information, such as your age, gender, hometown, and interests, that you voluntarily give to us when you register with the App.',
      ],
    },
    {
      header: 'b. Derivative Information',
      body: [
        'Information our servers automatically collect when you access the App, such as your IP address, your browser type, your operating system, your access times, and the pages you have viewed directly before and after accessing the App.',
      ],
    },
    {
      header: 'c. Financial Information',
      body: [
        'Financial information, such as data related to your payment method (e.g., valid credit card number, card brand, expiration date) that we may collect when you purchase, order, return, exchange, or request information about our services from the App.',
      ],
    },
    {
      header: 'd. Mobile Device Access',
      body: [
        'We may request access or permission to certain features from your mobile device, including your mobile device’s camera, contacts, reminders, sensors, SMS messages, social media accounts, storage, and other features. If you wish to change our access or permissions, you may do so in your device’s settings.',
      ],
    },
    {
      header: 'e. Mobile Device Data',
      body: [
        'Device information such as your mobile device ID number, model, and manufacturer, version of your operating system, phone number, country, location, and any other data you choose to provide.',
      ],
    },
    {
      header: 'f. Push Notifications',
      body: [
        'We may request to send you push notifications regarding your account or the App. If you wish to opt-out from receiving these types of communications, you may turn them off in your device’s settings.',
      ],
    },
    {
      header: 'g. Content',
      body: ['We collect the content you upload or create within the App, such as text, images, video, and locations.'],
    },
    {
      header: '3. Use of Your Information',
      body: [
        'We use your information to:',
        '•	Create and manage your account.',
        '•	Process your transactions and send related information, including purchase confirmation and invoices',
        '•	Email you regarding your account or order.',
        '•	Deliver targeted advertising, coupons, newsletters, and other information regarding promotions and the App to you.',
        '•	Fulfill and manage purchases, orders, payments, and other transactions related to the App.',
        '•	Generate a personal profile about you to make future visits to the App more personalized.',
        '•	Increase the efficiency and operation of the App.',
        '•	Monitor and analyze usage and trends to improve your experience with the App.',
        '•	Notify you of updates to the App.',
        '•	Offer new products, services, mobile applications, and/or recommendations to you.',
        '•	Perform other business activities as needed.',
        '•	Prevent fraudulent transactions, monitor against theft, and protect against criminal activity.',
        '•	Request feedback and contact you about your use of the App.',
        '•	Resolve disputes and troubleshoot problems.',
        '•	Respond to product and customer service requests.',
        '•	Send you a newsletter.',
        '•	Solicit support for the App.',
      ],
    },
    {
      header: '4. Disclosure of Your Information',
      body: [
        'We may share information we have collected about you in certain situations. Your information may be disclosed as follows:',
      ],
    },
    {
      header: 'a. By Law or to Protect Rights',
      body: [
        'If we believe the release of information about you is necessary to respond to legal process, to investigate or remedy potential violations of our policies, or to protect the rights, property, and safety of others, we may share your information as permitted or required by any applicable law, rule, or regulation.',
      ],
    },
    {
      header: 'b. Third-Party Service Providers',
      body: [
        'We may share your information with third parties that perform services for us or on our behalf, including payment processing, data analysis, email delivery, hosting services, customer service, and marketing assistance.',
      ],
    },
    {
      header: 'c. Marketing Communications',
      body: [
        'With your consent, or with an opportunity for you to withdraw consent, we may share your information with third parties for marketing purposes, as permitted by law.',
      ],
    },
    {
      header: 'd. Interactions with Other Users',
      body: [
        'If you interact with other users of the App, those users may see your name, profile photo, and descriptions of your activity, including sending invitations to other users, chatting with other users, liking posts, and following blogs.',
      ],
    },
    {
      header: 'e. Online Postings',
      body: [
        'When you post comments, contributions, or other content to the App, your posts may be viewed by all users and may be publicly distributed outside the App in perpetuity.',
      ],
    },
    {
      header: 'f. Third-Party Advertisers',
      body: [
        'We may use third-party advertising companies to serve ads when you visit the App. These companies may use information about your visits to the App and other websites that are contained in web cookies to provide advertisements about goods and services of interest to you.',
      ],
    },
    {
      header: 'g. Affiliates',
      body: [
        'We may share your information with our affiliates, in which case we will require those affiliates to honor this Privacy Policy. Affiliates include our parent company and any subsidiaries, joint venture partners, or other companies that we control or that are under common control with us.',
      ],
    },
    {
      header: 'h. Business Partners',
      body: [
        'We may share your information with our business partners to offer you certain products, services, or promotions.',
      ],
    },
    {
      header: 'i. Other Third Parties',
      body: [
        'We may share your information with advertisers and investors for the purpose of conducting general business analysis. We may also share your information with such third parties for marketing purposes, as permitted by law.',
      ],
    },
    {
      header: 'j. Sale or Bankruptcy',
      body: [
        'If we reorganize or sell all or a portion of our assets, undergo a merger, or are acquired by another entity, we may transfer your information to the successor entity. If we go out of business or enter bankruptcy, your information would be an asset transferred or acquired by a third party. You acknowledge that such transfers may occur and that the transferee may decline honor commitments we made in this Privacy Policy.',
      ],
    },
    {
      header: '5. Tracking Technologies',
      body: [
        'We may use cookies, web beacons, tracking pixels, and other tracking technologies on the App to help customize the App and improve your experience. When you access the App, your personal information is not collected through the use of tracking technology. Most browsers are set to accept cookies by default. You can remove or reject cookies, but be aware that such action could affect the availability and functionality of the App.',
      ],
    },
    {
      header: 'a. Cookies and Web Beacons',
      body: [
        'We may use cookies, web beacons, tracking pixels, and other tracking technologies on the App to help customize the App and improve your experience. When you access the App, your personal information is not collected through the use of tracking technology. Most browsers are set to accept cookies by default. You can remove or reject cookies, but be aware that such action could affect the availability and functionality of the App.',
      ],
    },
    {
      header: 'b. Internet-Based Advertising',
      body: [
        'Additionally, we may use third-party software to serve ads on the App, implement email marketing campaigns, and manage other interactive marketing initiatives. This third-party software may use cookies or similar tracking technology to help manage and optimize your online experience with us.',
      ],
    },
    {
      header: 'c. Website Analytics',
      body: [
        'We may also partner with selected third-party vendors, such as Google Analytics, to allow tracking technologies and remarketing services on the App through the use of first-party cookies and third-party cookies, to, among other things, analyze and track users’ use of the App, determine the popularity of certain content, and better understand online activity. By accessing the App, you consent to the collection and use of your information by these third-party vendors.',
      ],
    },
    {
      header: '6. Third-Party Websites',
      body: [
        'The App may contain links to third-party websites and applications of interest, including advertisements and external services, that are not affiliated with us. Once you have used these links to leave the App, any information you provide to these third parties is not covered by this Privacy Policy, and we cannot guarantee the safety and privacy of your information. Before visiting and providing any information to any third-party websites, you should inform yourself of the privacy policies and practices (if any) of the third party responsible for that website, and should take those steps necessary to, in your discretion, protect the privacy of your information. We are not responsible for the content or privacy and security practices and policies of any third parties, including other sites, services, or applications that may be linked to or from the App.',
      ],
    },
    {
      header: '7. Security of Your Information',
      body: [
        'We use administrative, technical, and physical security measures to help protect your personal information. While we have taken reasonable steps to secure the personal information you provide to us, please be aware that despite our efforts, no security measures are perfect or impenetrable, and no method of data transmission can be guaranteed against any interception or other type of misuse.',
      ],
    },
    {
      header: '8. Policy for Children',
      body: [
        'We do not knowingly solicit information from or market to children under the age of 13. If we learn that we have collected personal information from a child under age 13 without verification of parental consent, we will delete that information as quickly as possible. If you believe we might have any information from or about a child under 13, please contact us at [contact information].',
      ],
    },
    {
      header: '9. Controls for Do-Not-Track Features',
      body: [
        'Most web browsers and some mobile operating systems include a Do-Not-Track ("DNT") feature or setting you can activate to signal your privacy preference not to have data about your online browsing activities monitored and collected. No uniform technology standard for recognizing and implementing DNT signals has been finalized. As such, we do not currently respond to DNT browser signals or any other mechanism that automatically communicates your choice not to be tracked online. If a standard for online tracking is adopted that we must follow in the future, we will inform you about that practice in a revised version of this Privacy Policy.',
      ],
    },
    {
      header: '10. Options Regarding Your Information',
      body: [
        'a. Account Information',
        'You may at any time review or change the information in your account or terminate your account by:',
        '•	Logging into your account settings and updating your account',
        '•	Contacting us using the contact information provided below',
        'Upon your request to terminate your account, we will deactivate or delete your account and information from our active databases. However, some information may be retained in our files to prevent fraud, troubleshoot problems, assist with any investigations, enforce our Terms of Use and/or comply with legal requirements.',
      ],
    },
    {
      header: 'b. Emails and Communications',
      body: [
        'If you no longer wish to receive correspondence, emails, or other communications from us, you may opt-out by:',
        '•	Noting your preferences at the time you register your account with the App',
        '•	Logging into your account settings and updating your preferences',
        '•	Contacting us using the contact information provided below',
        'If you no longer wish to receive correspondence, emails, or other communications from third parties, you are responsible for contacting the third party directly.',
      ],
    },
    {
      header: '11. Contact Us',
      body: [
        'If you have questions or comments about this Privacy Policy, please contact us at:',
        'AtCreate Inc.',
        '269, 3553-31 Street NW, Calgary AB, T2L 2K7, Canada.',
        'support@atcreate.ca',
      ],
    },
  ],
}
